import api from 'utils/apiClient';

export const getKeyWords = (params) => {
  return api.get('/moderation_keywords', { params });
};

export const deleteKeyWords = (id) => {
  if (Array.isArray(id)) {
    return api.delete(`/moderation_keywords/bulk_delete?items=${id.join(',')}`);
  } else {
    return api.delete(`/moderation_keywords/${id}`);
  }
};

export const editKeyWord = ({ id, keyword, ...data }) => {
  return api.patch(`/moderation_keywords/${id}`, { keyword }, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
    },
    notification: {
      visible: false,
    },
  });
};

export const createKeyWords = (data) => {
  return api.post('/moderation_keywords/create', data);
};
